import React, { useState, useEffect, ReactNode } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataTable } from "capitalrx-components";
import { checkDate } from "capitalrx-utilities";
import { useNavigate } from "react-router";

import { RootState } from "@/App/reducers";

import { getBatchTestClaimListActions } from "@/App/actions";

import { GeneralTypes } from "@/types";

const INITIAL_QUERY_OPTIONS = {
  order_by: [{ created_at: GeneralTypes.SortOrder.Desc }],
  page_number: 1,
  results_per_page: 20,
};

const ResultsTable: React.FC = () => {
  const navigate = useNavigate();
  const { batchTestClaimListResults } = useSelector((state: RootState) => state.batchTestClaimList);
  const { results, result_count } = batchTestClaimListResults;

  const [initialQuery, setInitialQuery] = useState<GeneralTypes.QueryOptions>(INITIAL_QUERY_OPTIONS);

  const { getTestClaimList } = getBatchTestClaimListActions;

  const loading = result_count === "0";
  const dispatch = useDispatch();

  const handleUpdate = (queryOptions: GeneralTypes.QueryOptions): void => {
    setInitialQuery(queryOptions);
    dispatch(getTestClaimList({ queryOptions: queryOptions }));
  };

  useEffect(() => {
    handleUpdate(initialQuery);
  }, []);

  const tableOnClick = (e: { id: string }): void => {
    navigate(`/test-claim/batch/view/${e.id}`);
  };

  const tableHeaders = [
    {
      key: "created_at",
      label: "Uploaded On",
      formatter: (value: string): string => {
        return checkDate(value);
      },
    },
    {
      key: "original_name",
      label: "File Name",
    },

    {
      key: "status",
      label: "Status",
      formatter: (label: string): ReactNode => {
        let component = <span>Uploaded</span>;

        if (label === "processed") {
          component = <span className="caprx-icon-successcheck">Processed</span>;
        }

        if (label === "processing") {
          component = <span className="caprx-icon-dots">Processing</span>;
        }

        return component;
      },
    },
    {
      "key": "display_status",
      "label": "Progress",
    },
  ];

  const resultHeader = results && `${result_count} batch claim(s) found:`;

  return (
    <div className="table-section-container-wrapper">
      <div className="table-section-result-header">{resultHeader}</div>
      <DataTable
        data={results}
        handleUpdateRequest={handleUpdate}
        resultsTotalCount={result_count}
        headers={tableHeaders}
        searchIsEnabled={false}
        queryOptions={initialQuery}
        isLoading={loading}
        rowIsClickable
        ableToSort={false}
        onClick={tableOnClick}
      />
    </div>
  );
};

export default ResultsTable;
